<!--
  https://github.com/vuetifyjs/vuetify/issues/9406#issuecomment-586830603
-->
<template>
  <div>
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'StopListGroup',
  provide() {
    return {
      isInGroup: false,
      listItemGroup: undefined,
    }
  },
}
</script>
